import { render, staticRenderFns } from "./CardSuggestedReviews.vue?vue&type=template&id=6fed3e06&scoped=true&"
import script from "./CardSuggestedReviews.vue?vue&type=script&lang=js&"
export * from "./CardSuggestedReviews.vue?vue&type=script&lang=js&"
import style0 from "./CardSuggestedReviews.vue?vue&type=style&index=0&id=6fed3e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fed3e06",
  null
  
)

export default component.exports